import { useQuery, useQueryClient } from "@tanstack/react-query";
import type { ConfigBundleViewModel } from "../types/viewmodel";

export const VIEWMODEL_QUERY_KEY = "configBundleViewModel";

export function useViewModel() {
	const queryClient = useQueryClient();

	return useQuery<ConfigBundleViewModel>({
		queryKey: [VIEWMODEL_QUERY_KEY],
		queryFn: () => {
			throw new Error("ViewModel query function should not be called - data should be hydrated from server");
		},
		initialData: () => queryClient.getQueryData<ConfigBundleViewModel>([VIEWMODEL_QUERY_KEY]),
		staleTime: 1000 * 60 * 5,
		gcTime: 1000 * 60 * 10,
		refetchOnMount: false,
		refetchOnWindowFocus: false,
		refetchOnReconnect: false,
		enabled: !!queryClient.getQueryData<ConfigBundleViewModel>([VIEWMODEL_QUERY_KEY]),
	});
}

export function getViewModelFromCache(queryClient: ReturnType<typeof useQueryClient>): ConfigBundleViewModel | undefined {
	return queryClient.getQueryData<ConfigBundleViewModel>([VIEWMODEL_QUERY_KEY]);
}

/**
 * Returns whether the current store is a B2B store.
 * B2B stores show net prices (excl. VAT) instead of gross prices.
 */
export function useIsB2B(): boolean {
	const { data } = useViewModel();
	return data?.isB2B ?? false;
}